import React, {useState} from 'react'
import {useEyeconxStore} from '../../../store/eyeconxStore'
import {NavLink, useLocation, useNavigate} from 'react-router-dom'
import {Tooltip} from 'react-tooltip'

function SmsNav() {
    const logout = useEyeconxStore(state => state.logout)
    const navigate = useNavigate()
    const location = useLocation()
    const [menuOpen, setMenuOpen] = useState(false);
    const notifications = useEyeconxStore((state) => state.notifications);
    const resetNotifications = useEyeconxStore((state) => state.resetNotifications);

    // Get current tab info from route
    const getCurrentTab = () => {
        const path = location.pathname;
        if (path.includes('sms-dashboard')) return {
            name: 'Dashboard',
            icon: 'bi-speedometer2',
            color: 'text-primary'
        };
        if (path.includes('sms-messages')) return {
            name: 'Messages',
            icon: 'bi-chat-left-text',
            color: 'text-success'
        };
        if (path.includes('sms-clinic-settings')) return {
            name: 'Settings',
            icon: 'bi-gear',
            color: 'text-info'
        };
        if (path.includes('sms-notifications')) return {
            name: 'Notifications',
            icon: 'bi-bell',
            color: 'text-warning'
        };
        return null;
    }

    const currentTab = getCurrentTab();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleLogout = () => {
        logout()
        navigate('/login')
    }

    const handlenotify = () => {
        resetNotifications()
        navigate('/sms-messages')
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm px-1 p-0">
            <div className="container-fluid p-3">
                {/* Brand/Title with current section */}
                <div className="d-flex align-items-center">
                    <span className="navbar-brand mb-0 h5 fw-bold text-dark me-4">
                        <i className="bi bi-chat-square-text-fill me-2 text-primary"></i>
                        EyeconX SMS Gateway
                    </span>

                    {/* Current Section with Icon - Desktop */}
                    {currentTab && (
                        <div className={`d-none d-md-flex align-items-center ${currentTab.color}`}>
                            <div className="vr mx-2 opacity-50" style={{height: '24px'}}></div>
                            <i className={`bi ${currentTab.icon} me-2`}></i>
                            <span className="fw-medium">{currentTab.name}</span>
                        </div>
                    )}
                </div>

                {/* Mobile menu button */}
                <button
                    className="navbar-toggler border-0"
                    type="button"
                    onClick={toggleMenu}
                    aria-expanded={menuOpen}
                    aria-label="Toggle navigation"
                >
                    <i className={`bi ${menuOpen ? 'bi-x-lg' : 'bi-list'}`}></i>
                </button>

                {/* Navigation items */}
                <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`}>
                    <ul className="navbar-nav ms-auto align-items-lg-center">
                        {/* Notification Bell */}
                        <li className="nav-item me-lg-3">
                            <div
                                className="position-relative nav-link p-2 rounded-3"
                                onClick={handlenotify}
                                style={{cursor: 'pointer', transition: 'all 0.2s'}}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                            >
                                <i className="bi bi-bell fs-5"></i>
                                {notifications > 0 && (
                                    <span
                                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                        style={{fontSize: '0.6rem'}}>
                                        {notifications > 9 ? '9+' : notifications}
                                    </span>
                                )}
                            </div>
                        </li>

                        {/* Desktop Menu Items */}
                        <li className="nav-item d-none d-md-block">
                            <NavLink
                                to={'sms-dashboard'}
                                className={({isActive}) =>
                                    `nav-link px-3 py-2 rounded-3 mx-1 ${isActive ? 'bg-primary bg-opacity-10 text-primary fw-medium' : 'text-dark'}`
                                }
                            >
                                <i className="bi bi-speedometer2 me-2"></i>
                                Dashboard
                            </NavLink>
                        </li>
                        <li className="nav-item d-none d-md-block">
                            <NavLink
                                to={'sms-messages'}
                                className={({isActive}) =>
                                    `nav-link px-3 py-2 rounded-3 mx-1 ${isActive ? 'bg-success bg-opacity-10 text-success fw-medium' : 'text-dark'}`
                                }
                            >
                                <i className="bi bi-chat-left-text me-2"></i>
                                Messages
                            </NavLink>
                        </li>
                        <li className="nav-item d-none d-md-block">
                            <NavLink
                                to={'sms-clinic-settings'}
                                className={({isActive}) =>
                                    `nav-link px-3 py-2 rounded-3 mx-1 ${isActive ? 'bg-info bg-opacity-10 text-info fw-medium' : 'text-dark'}`
                                }
                            >
                                <i className="bi bi-gear me-2"></i>
                                Settings
                            </NavLink>
                        </li>

                        {/* Logout - Desktop */}
                        <li className="nav-item d-none d-md-block ms-lg-2">
                            <button
                                className="nav-link px-3 py-2 rounded-3 text-danger"
                                onClick={handleLogout}
                                data-tooltip-id="logout-tooltip"
                                data-tooltip-content="Logout"
                                data-tooltip-place="bottom"
                                style={{transition: 'all 0.2s'}}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(220,53,69,0.1)'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                            >
                                <i className="bi bi-box-arrow-right me-2"></i>
                                Logout
                            </button>
                            <Tooltip id="logout-tooltip"/>
                        </li>

                        {/* Mobile Menu Items */}
                        <li className="nav-item d-block d-md-none mt-2">
                            <NavLink
                                onClick={toggleMenu}
                                to={'sms-dashboard'}
                                className={({isActive}) =>
                                    `nav-link px-3 py-3 rounded-3 ${isActive ? 'bg-primary bg-opacity-10 text-primary fw-medium' : 'text-dark'}`
                                }
                            >
                                <i className="bi bi-speedometer2 me-2"></i>
                                Dashboard
                            </NavLink>
                        </li>
                        <li className="nav-item d-block d-md-none">
                            <NavLink
                                onClick={toggleMenu}
                                to={'sms-messages'}
                                className={({isActive}) =>
                                    `nav-link px-3 py-3 rounded-3 ${isActive ? 'bg-success bg-opacity-10 text-success fw-medium' : 'text-dark'}`
                                }
                            >
                                <i className="bi bi-chat-left-text me-2"></i>
                                Messages
                            </NavLink>
                        </li>
                        <li className="nav-item d-block d-md-none">
                            <NavLink
                                onClick={toggleMenu}
                                to={'sms-clinic-settings'}
                                className={({isActive}) =>
                                    `nav-link px-3 py-3 rounded-3 ${isActive ? 'bg-info bg-opacity-10 text-info fw-medium' : 'text-dark'}`
                                }
                            >
                                <i className="bi bi-gear me-2"></i>
                                Settings
                            </NavLink>
                        </li>
                        <li className="nav-item d-block d-md-none border-top mt-2 pt-2">
                            <button
                                className="nav-link px-3 py-3 rounded-3 text-danger w-100 text-start"
                                onClick={handleLogout}
                            >
                                <i className="bi bi-box-arrow-right me-2"></i>
                                Logout
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default SmsNav